import makeStyles from '@material-ui/core/styles/makeStyles';
import twitterBtnStyles from '../styles/customTwitterBtn.styles';

const useTwitterBtnStyles = makeStyles(twitterBtnStyles);

export { twitterBtnStyles, useTwitterBtnStyles };